// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Layout, Menu, Divider, Button, theme, Input } from 'antd';
// import { useSelector } from 'react-redux';
// import { useAppContext } from '@/context/appContext';
// import logoIcon from '@/style/images/logo-icon.png';
// import logoText from '@/style/images/logo-text.png';
// import {
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
//   DashboardTwoTone,
//   MessageTwoTone,
//   ReconciliationTwoTone,
//   BugTwoTone,
//   ProjectTwoTone,
//   MenuOutlined,
//   ProfileTwoTone,
//   ContactsTwoTone,
//   DollarTwoTone,
//   CarryOutTwoTone,
//   FileAddTwoTone,
//   FolderOpenTwoTone,
//   AlertTwoTone,
//   TagTwoTone,
//   BookTwoTone,
//   IdcardTwoTone,
//   HomeOutlined,
//   HomeTwoTone,
//   GiftTwoTone,
//   ContainerOutlined,
//   ContainerTwoTone,
//   FileTextTwoTone,
//   HourglassTwoTone,
//   WalletTwoTone,
//   TeamOutlined,
//   SmileTwoTone
// } from '@ant-design/icons';
// import { selectCurrentAdmin } from '@/redux/auth/selectors';
// import useMediaQuery from '@/hooks/useMediaQuery/useMediaQuery';
// import './Navigation.css';

// const { Sider } = Layout;
// const { SubMenu } = Menu;

// export default function Navigation() {
//   const currentAdmin = useSelector(selectCurrentAdmin);
//   const { state: stateApp, appContextAction } = useAppContext();
//   const { isNavMenuClose } = stateApp;
//   const { navMenu } = appContextAction;
//   const [collapsed, setCollapsed] = useState(true);
//   const [hover, setHover] = useState(false);
//   const {
//     token: { colorBgContainer },
//   } = theme.useToken();

//   const isMobile = useMediaQuery('(max-width: 1208px)');

//   useEffect(() => {
//     setCollapsed(isMobile || isNavMenuClose);
//   }, [isNavMenuClose, isMobile]);

//   const onCollapse = () => {
//     setCollapsed(!collapsed);
//   };

//   return (
//     <>
//       <div className={`mobile-toggle-button ${isMobile ? '' : 'hidden'}`}>
//         <Button
//           type="text"
//           icon={collapsed ? <MenuOutlined /> : <MenuOutlined />}
//           onClick={onCollapse}
//           className="mobile-collapse-button"
//         />
//       </div>

//       {!isMobile || !collapsed ? (
//         <Sider
//           collapsible
//           trigger={null}
//           collapsed={collapsed}
//           onCollapse={onCollapse}
//           className={`navigation custom-sider ${isMobile && !collapsed ? 'expanded' : ''}`}
//         >
//           <div className="logo">
//             <img
//               src={logoIcon}
//               alt="Logo"
//               className={collapsed ? 'logo-icon' : 'logo-icon-expanded'}
//             />
//             {!collapsed && <img src={logoText} alt="Logo" className="logo-text" />}
//           </div>

//           <Button
//             type="text"
//             icon={collapsed ? <MenuOutlined /> : <MenuOutlined />}
//             onClick={onCollapse}
//             className="collapse-button"
//           />

//           {!collapsed && (
//             <div style={{ textAlign: 'center', padding: '20px 0' }}>
//               <img
//                 src="https://i.ibb.co/M1JfKsS/employee.gif"
//                 alt="User Avatar"
//                 style={{ width: '100px', height: '100px', borderRadius: '50%' }}
//               />
//               <p>{`${currentAdmin.name} ${currentAdmin.surname}`}</p>
//               <p>Employee</p>
//             </div>
//           )}

//           <Menu mode="inline">
//             <Divider />
//             <Menu.Item key={'home'} icon={<HomeTwoTone />}>
//               <Link to={'/'}>Home</Link>
//             </Menu.Item>
//             {
//               (currentAdmin?._id === '64ec6adc9c3ccb46c000dc14' || currentAdmin?.role?.toLowerCase() === 'client') &&
//               <Menu.Item key={'ClientTaskLog'} icon={<ProjectTwoTone />}>
//                 <Link to={'/client-task-log'}>Client Task Log</Link>
//               </Menu.Item>
//             }
//             {(currentAdmin?._id === '6591d57a913b9f2caaedbcd5' || currentAdmin?._id === '6591d11aabbe63958da9a7f2') ?
//               // { true ? 
//               <>
//                 <Menu.Item key={'birthdayBuzz'} icon={<GiftTwoTone />}>
//                   <Link to={'/birthday-buzz'}>Birthday Buzz</Link>
//                 </Menu.Item>
//                 {/* <Menu.Item key={'Annoucement'} icon={<AlertTwoTone />}>
//                   <Link to={'/create-announcement'}>Create Announcement</Link>
//                 </Menu.Item> */}
//               </> : null
//             }

//             <Menu.Item key={'AnnoucementFeeds'} icon={<TagTwoTone />}>
//               <Link to={'/announcement-feeds'}>Announcements</Link>
//             </Menu.Item>
//             {
//               currentAdmin?._id === '64edc23c092b5b033f2d7506' &&
//                 currentAdmin?._id === '65928ebca47b79405f20d62c'
//                 && currentAdmin?._id === '65a0e4f5bfc0d31b621905a0'
//                 ?

//                 <>
//                   <Menu.Item key={'invoices'} icon={<FileTextTwoTone />}>
//                     <Link to={'/maintenance'}>Invoices</Link>
//                   </Menu.Item>
//                 </> : null
//             }

//             {/* <Menu.Item key={'focusPing'} icon={<TagTwoTone />}>
//               <Link to={'/focusPing'}>FocusPing</Link>
//             </Menu.Item> */}
//             <Menu.Item key={'LeaveRequestsList'} icon={<ContainerTwoTone />} >
//               <Link to={'/LeaveRequestList'}>Leave Requests</Link>
//             </Menu.Item>
//             <Menu.Item key={'EmployeeHandbook'} icon={< BookTwoTone />}>
//               <a
//                 style={{ color: hover ? 'white' : 'black', transition: 'color 0.3s ease' }}
//                 onMouseEnter={() => setHover(true)}
//                 onMouseLeave={() => setHover(false)}
//                 href="https://drive.google.com/file/d/1_mEOAw455vIMxJi7zKp-MmRcxt1N4Nd3/view?usp=drive_link"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Employee Handbook
//               </a>
//             </Menu.Item>
//             {/* <Menu.Item key={'extraHours'} icon={<HourglassTwoTone />}>
//               <Link to={'/extraHours'}>Extra Hours</Link>
//             </Menu.Item> */}
//             {/* <Menu.Item key={'payrolls'} icon={<WalletTwoTone />}>
//               <Link to={'/payrolls'}>Payroll</Link>
//             </Menu.Item> */}
//             <Menu.Item key={'activityScorecard'} icon={<IdcardTwoTone />}>
//               <Link to={'/activity-scorecard'}>View Scorecard</Link>
//             </Menu.Item>
//             {/* <Menu.Item key={'Invoice'} icon={<MessageTwoTone />}>
//               <Link to={'/invoice'}>Inbox</Link>
//             </Menu.Item> */}
//             {
//               currentAdmin?.department === 'Marketing' &&
//               <>
//                 {!collapsed && (
//                   <Menu.Item key={'Divider'} disabled>
//                     <span className="sidebar-heading">Apps</span>
//                   </Menu.Item>
//                 )}

//                 <Divider />
//                 <SubMenu
//                   key={'Marketing Tools'}
//                   icon={<ReconciliationTwoTone />}
//                   title={'Marketing Tools'}
//                 >
//                   <Menu.Item key={'TimeInRecords'}>
//                     <Link to={'/colorpicker'}>Color Picker</Link>
//                   </Menu.Item>

//                   <Menu.Item key={'MetaLengthChecker'}>
//                     <Link to={'/meta-length-checker'}>Meta Length Checker</Link>
//                   </Menu.Item>

//                   <Menu.Item key={'AITextDetector'}>
//                     <Link to={'/ai-text-detector'}>AI Text Detector</Link>
//                   </Menu.Item>

//                   <Menu.Item key={'PageSpeedInsights'}>
//                     <Link to={'/page-speed-insights'}>Page Speed Insights</Link>
//                   </Menu.Item>
//                   <Menu.Item key={'speechToText'}>
//                     <Link to={'/voice-over'}>Text to Speech</Link>
//                   </Menu.Item>
//                   <Menu.Item key={'Google Trends'}>
//                     <Link to={'/google-trends'}>Google Trends</Link>
//                   </Menu.Item>
//                   <Menu.Item key={'Google Keywords Planner'}>
//                     <Link to={'/google-keywords-planner'}>Google Keywords Planner</Link>
//                   </Menu.Item>
//                 </SubMenu>

//                 {!collapsed && (
//                   <Menu.Item key={'Divider'} disabled>
//                     <span className="sidebar-heading">Forms</span>
//                   </Menu.Item>
//                 )}

//                 <Divider />
//               </>

//             }

//             {/* <Menu.Item key={'Complaint'} icon={<BugTwoTone />}>
//               <Link to={'/complaint'}>Complaint Form</Link>
//             </Menu.Item> */}

//             <SubMenu
//               key={'Feedbacks and Requests'}
//               icon={<ProjectTwoTone />}
//               title={'Feedback & Request'}
//             >
//               <Menu.Item key={'LeavesForm'}>
//                 <Link to={'/leaves'}>Leave Application</Link>
//               </Menu.Item>
//               <Menu.Item key={'SuggestionsComplaintForm'}>
//                 <Link to={'/suggestions&complaints'}>Submit Feedback/Complaint </Link>
//               </Menu.Item>


//               {
//                 (currentAdmin?._id === '6591d57a913b9f2caaedbcd5' || currentAdmin?._id === '6591d11aabbe63958da9a7f2' || currentAdmin?._id === '64ec6adc9c3ccb46c000dc14') &&
//                 <>
//                   <Menu.Item key={'suggestionList'}>
//                     <Link to={'/suggestion-list'}>Feedback & Complaint Log</Link>
//                   </Menu.Item>
//                 </>
//               }
//             </SubMenu>

//             {(currentAdmin?._id === '6591d57a913b9f2caaedbcd5' || currentAdmin?._id === '6591d11aabbe63958da9a7f2' || currentAdmin?._id === '64ec6adc9c3ccb46c000dc14') && (
//               <SubMenu key={'Reports'} icon={<ReconciliationTwoTone />} title={'Reports'}>
//                 <Menu.Item key={'AttendanceReport'}>
//                   <Link to={'/daily-activity-log'}>Daily Activity Log</Link>
//                 </Menu.Item>
//                 <Menu.Item key={'TechnicianLogs'}>
//                   <Link to={'/technician-logs'}>Technicians Activity</Link>
//                 </Menu.Item>


//                 {/* <Menu.Item key={'TimeInRecords'}>
//                   <Link to={'/time-in-records'}>Time-in Records</Link>
//                 </Menu.Item> */}

//                 {/* <Menu.Item key={'MonthlySummary'}>
//                   <Link to={'/attendance-report'}>Attendance Report</Link>
//                 </Menu.Item> */}

//                 <Menu.Item key={'MonthlySummary'}>
//                   <Link to={'/attendance-report'}>Time-in / Time-out</Link>
//                 </Menu.Item>

//                 {/* <Menu.Item key={'ExtraHours'}>
//                   <Link to={'/extra-hours-logs'}>Extra Hours Logs</Link>
//                 </Menu.Item> */}
//                 <Menu.Item key={'OvertimeTable'}>
//                   <Link to={'/overtime-extrahours'}>Overtime and Deductions</Link>
//                 </Menu.Item>

//               </SubMenu>
//             )}

//             {(currentAdmin?._id === '6591d57a913b9f2caaedbcd5' || currentAdmin?._id === '6591d11aabbe63958da9a7f2' || currentAdmin?._id === '64ec6adc9c3ccb46c000dc14') &&
//               (
//                 <>

//                   <Menu.Item key={'HRHeading'} disabled>
//                     {!collapsed &&
//                       <span style={{ wordBreak: 'break' }} className="sidebar-heading">Human Resources</span>
//                     }
//                   </Menu.Item>

//                   <Menu.Item key={'Recruitment'} icon={<ContactsTwoTone />}>
//                     <Link to={'/recruitment'}>Recruitment Panel</Link>
//                   </Menu.Item>

//                   <Menu.Item key={'Employees'} icon={<ProfileTwoTone />}>
//                     <Link to={'/employees'}>Employee Management</Link>
//                   </Menu.Item>

//                   <Menu.Item key={'SalarySlipForm'} icon={<DollarTwoTone />}>
//                     <Link to={'/salary-management'}>Salary Management</Link>
//                   </Menu.Item>
//                   <Menu.Item key={'hiringRequisitionPanal'} icon={<FolderOpenTwoTone />}>
//                     <Link to={'/hire-req'}>Open Positions</Link>
//                   </Menu.Item>
//                   <Menu.Item key={'hiringRequisitionRequest'} icon={<FileAddTwoTone />}>
//                     <Link to={'/hire-req/create'}>Hiring Requests</Link>
//                   </Menu.Item>
//                   {/* 
//                 <Menu.Item key={'RegisterUuser'} icon={<CarryOutTwoTone />}>
//                     <Link to={'/register-user'}>Register User</Link>
//                   </Menu.Item>
//                 <Menu.Item key={'Users'} icon={<SmileTwoTone />}>
//                     <Link to={'/users'}>Users</Link>
//                   </Menu.Item> */}
//                 </>
//               )}
//           </Menu>
//         </Sider>
//       ) : null}
//     </>
//   );
// }




import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Divider, Button, theme, Modal, Spin, List, Image, Popover, Badge } from 'antd';
import { useSelector } from 'react-redux';
import { useAppContext } from '@/context/appContext';
import logoIcon from '@/style/images/logo-icon.png';
import logoText from '@/style/images/logo-text.png';

import {
  MenuOutlined,
  ReconciliationTwoTone,
  ProjectTwoTone,
  TagTwoTone,
  BookTwoTone,
  IdcardTwoTone,
  HomeTwoTone,
  GiftTwoTone,
  ContainerTwoTone,
  FileTextTwoTone,
  ContactsTwoTone,
  ProfileTwoTone,
  DollarTwoTone,
  FolderOpenTwoTone,
  FileAddTwoTone,
  SettingTwoTone,
  SafetyCertificateOutlined,
  HourglassTwoTone,
  SettingOutlined,
  UserOutlined,
  CameraOutlined,
  CheckCircleTwoTone,
  CarryOutTwoTone,
} from '@ant-design/icons';

import { selectCurrentAdmin } from '@/redux/auth/selectors';
import useMediaQuery from '@/hooks/useMediaQuery/useMediaQuery';
import './Navigation.css';
import axios from 'axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { user } from 'elevenlabs/api';
import { usePermission } from '@/customHooks/usePermission';
import { BASE_URL } from "@/config/serverApiConfig";
import { Alert, Tag, Tooltip } from 'antd';

// Import your centralized role permissions object
// import { rolePermissions } from '../../settings/rolePermissions'; // adjust path if needed

const { Sider } = Layout;
const { SubMenu } = Menu;



export default function Navigation() {
  const isDarkMode = useSelector(state => state.theme.isDarkMode);
  const currentAdmin = useSelector(selectCurrentAdmin);
  const { state: stateApp, appContextAction } = useAppContext();
  const { isNavMenuClose } = stateApp;
  const { navMenu } = appContextAction;
  const [collapsed, setCollapsed] = useState(true);
  const [hover, setHover] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const isMobile = useMediaQuery('(max-width: 1208px)');
  const [isSettingsModalVisible, setIsSettingsModalVisible] = useState(false);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);
  const [leaveCount, setLeaveCount] = useState(0);
  const [selfAppraisalCount, setSelfAppraisalCount] = useState(0);
  const [reviewAppraisalCount, setReviewAppraisalCount] = useState(0);

  useEffect(() => {
    const fetchCounts = async () => {
      if (!currentAdmin) return;
      try {
        const [leaveRes, appraisalRes] = await Promise.allSettled([
          axios.get('/get-leave-request'),
          axios.get('/appraisals')
        ]);

        if (leaveRes.status === 'fulfilled') {
          const data = leaveRes.value.data;
          setLeaveCount(Array.isArray(data) ? data.filter(l => !l.status || l.status.toLowerCase() === 'pending').length : 0);
        }

        if (appraisalRes.status === 'fulfilled') {
          const appraisals = appraisalRes.value.data.data || [];
          setSelfAppraisalCount(appraisals.filter(a => a.status === 'pending_self' && a.matchedBy === 'employee').length);
          setReviewAppraisalCount(appraisals.filter(a =>
            (a.status === 'pending_manager' && a.matchedBy === 'manager') ||
            (a.status === 'pending_hr' && (currentAdmin.role?.toLowerCase() === 'hr_admin' || currentAdmin.role?.toLowerCase() === 'super_admin'))
          ).length);
        }
      } catch (error) {
        console.error("Error fetching navigation counts:", error);
      }
    };
    fetchCounts();
  }, [currentAdmin]);

  const openSettingsModal = () => setIsSettingsModalVisible(true);
  const closeSettingsModal = () => setIsSettingsModalVisible(false);
  const currentAdminRole = currentAdmin?.role; // 'super_admin', 'admin', 'hr_admin', etc.

  const history = useHistory();
  useEffect(() => {
    setCollapsed(isMobile || isNavMenuClose);
  }, [isNavMenuClose, isMobile]);

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };
  const { canView, canCreate, canEdit, canDelete, canExport } = usePermission('MyProfile');
  const settingsOptions = [
    // Only show Roles & Permissions if user can view and has allowed role
    (canCreate && canEdit && canExport) && {
      key: 'roles-permissions',
      title: 'Roles & Permissions',
      icon: <SafetyCertificateOutlined />,
      path: '/roles-permissions',
      description: 'Manage user roles and permissions',
    },
  ].filter(Boolean); // remove falsey values

  const handleSettingClick = (path) => {
    setSettingsModalOpen(false);
    history.push(path);
  };





  const userRole = currentAdmin?.role || 'Employee';



  const hasAccess = (moduleName) => {
    if (!currentAdmin?.permissions || !moduleName) return false;
    const moduleLower = moduleName.toLowerCase();
    // Check if user has any permissions for this module
    return Object.keys(currentAdmin.permissions).some(permModule => {
      const permLower = permModule.toLowerCase();
      return moduleLower.includes(permLower) || permLower.includes(moduleLower) || moduleLower == permLower || permLower == moduleLower;
    });
  };
  // const hasAccess = (moduleName) => {
  //   if (!currentAdmin?.permissions || !moduleName) return false;

  //   const moduleLower = moduleName.toLowerCase();
  //   // Check if user has any permissions for this module
  //   return Object.keys(currentAdmin.permissions).some(permModule => {
  //     const permLower = permModule.toLowerCase();
  //     console.log(permLower.includes(moduleLower), permLower.includes(moduleLower), 'moduleLower', moduleLower)
  //     return moduleLower.includes(permLower) || permLower.includes(moduleLower);
  //   });
  // };


  const roleNameMap = {
    super_admin: "Super Admin",
    admin: "Admin",
    hr_admin: "HR Admin",
    finance_admin: "Finance Admin",
    manager: "Manager",
    employee: "Employee",
    client: "Client",
  };

  const [profileStatus, setProfileStatus] = useState(null);

  useEffect(() => {
    const fetchProfileStatus = async () => {
      try {
        const { data } = await axios.get('/my/profile');
        const status = data?.employee?.profileStatus || data?.employee?.profile_status || null;
        setProfileStatus(status);
      } catch (err) {
        setProfileStatus(null);
      }
    };

    if (currentAdmin?._id) {
      fetchProfileStatus();
    }
  }, [currentAdmin?._id]);

  const getProfileStatusMeta = () => {
    const status = profileStatus || 'Incomplete';
    if (status === 'Verified') {
      return { label: 'Profile Verified', color: 'green' };
    }
    if (status === 'Under_HR_Review' || status === 'Under HR Review') {
      return { label: 'Under HR Review', color: 'gold' };
    }
    return { label: 'Unverified', color: 'red' };
  };

  return (
    <>
      <div className={`mobile-toggle-button ${isMobile ? '' : 'hidden'}`}>
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={onCollapse}
          className="mobile-collapse-button"
        />
      </div>

      {!isMobile || !collapsed ? (
        <Sider
          collapsible
          trigger={null}
          collapsed={collapsed}
          onCollapse={onCollapse}
          className={`navigation custom-sider ${isMobile && !collapsed ? 'expanded' : ''}`}
        >

          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={onCollapse}
            className="collapse-button"
          />
          <div className="logo">
            {
              isMobile || collapsed ?
                <img src="logo192.png" alt="DymaxTech Logo" />
                :
                <img src="dymaxtech-logo-transparent.png" alt="DymaxTech Logo" />
            }

          </div>

          {!collapsed && (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <Image
                width={120}
                height={120}
                src={currentAdmin?.photo ? `${BASE_URL}public/uploads/admin/${currentAdmin?.photo}` : "https://i.ibb.co/M1JfKsS/employee.gif"}
                fallback="https://i.ibb.co/M1JfKsS/employee.gif"
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "4px solid #f0f0f0",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                }}
                preview={{
                  mask: <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><CameraOutlined /> Preview</div>
                }}
              />
              <p>{`${currentAdmin?.name} ${currentAdmin?.surname}`}</p>
              <p style={{ marginBottom: 4 }}>
                {roleNameMap[currentAdmin.role?.toLowerCase()] || currentAdmin.role}
              </p>
              {/* {currentAdmin?.role !== 'super_admin' && profileStatus && (
                <Tooltip title="Profile completion status">
                  <Tag
                    color={getProfileStatusMeta().color}
                    icon={
                      getProfileStatusMeta().label === 'Profile Verified'
                        ? <CheckCircleTwoTone twoToneColor="#52c41a" />
                        : undefined
                    }
                    style={{ marginTop: 4 }}
                  >
                    {getProfileStatusMeta().label}
                  </Tag>
                </Tooltip>
              )} */}
              {currentAdmin?.role !== 'super_admin' && profileStatus && (
                <div style={{ padding: '8px 16px' }}>
                  <Popover
                    trigger="hover"
                    placement="right"
                    content={
                      <>
                        {getProfileStatusMeta().label === 'Profile Incomplete' && (
                          <Alert
                            type="error"
                            showIcon
                            message="Profile incomplete — salary processing is on hold."
                            description={
                              <Button
                                type="link"
                                size="small"
                                style={{ padding: 0 }}
                                onClick={() => history.push('/my-profile')}
                              >
                                Complete My Profile
                              </Button>
                            }
                          />
                        )}

                        {getProfileStatusMeta().label === 'Under HR Review' && (
                          <Alert
                            type="info"
                            showIcon
                            message="Profile under HR review."
                            description="You will be notified once your profile is verified."
                          />
                        )}
                      </>
                    }
                  >
                    <Tag
                      color={getProfileStatusMeta().color}
                      icon={
                        getProfileStatusMeta().label === 'Profile Verified'
                          ? <CheckCircleTwoTone twoToneColor="#52c41a" />
                          : undefined
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      {getProfileStatusMeta().label}
                    </Tag>
                  </Popover>
                </div>
              )}
            </div>
          )}




          <Menu mode="inline">
            <Divider />
            <Menu.Item key={'home'} icon={<HomeTwoTone />}>
              <Link to={'/'}>Home</Link>
            </Menu.Item>

            {hasAccess('ClientTaskLog') &&
              <Menu.Item key={'ClientTaskLog'} icon={<ProjectTwoTone />}>
                <Link to={'/client-task-log'}>Client Task Log</Link>
              </Menu.Item>
            }

            <>
              {hasAccess('birthdayBuzz') &&
                <Menu.Item key={'birthdayBuzz'} icon={<GiftTwoTone />}>
                  <Link to={'/birthday-buzz'}>Birthday Buzz</Link>
                </Menu.Item>
              }
            </>
            <Menu.Item key={'extraHours'} icon={<HourglassTwoTone />}>
              <Link to={'/extraHours'}>Extra Hours</Link>
            </Menu.Item>
            <>
              {
                hasAccess('LeaveSummary') &&
                <Menu.Item key={'LeaveSummary'} icon={<GiftTwoTone />}>
                  <Link to={'/leavesummary'}>LeaveSummary</Link>
                </Menu.Item>
              }
            </>
            <>
              <Menu.Item key={'emailFeature'} icon={<GiftTwoTone />}>
                <Link to={'/email'}>Email</Link>
              </Menu.Item>
            </>

            {hasAccess('Annoucements') && (
              <Menu.Item key={'AnnoucementFeeds'} icon={<TagTwoTone />}>
                <Link to={'/announcement-feeds'}>Announcements</Link>
              </Menu.Item>
            )}

            {hasAccess('EventsReminders') && (
              <Menu.Item key={'EventsReminders'} icon={<CarryOutTwoTone />}>
                <Link to={'/events-reminders'}>Events & Reminders</Link>
              </Menu.Item>
            )}


            {hasAccess('maintenance') && (
              <>
                <Menu.Item key={'invoices'} icon={<FileTextTwoTone />}>
                  <Link to={'/maintenance'}>Invoices</Link>
                </Menu.Item>
              </>
            )}

            {hasAccess('LeaveRequestsList') && (
              <Menu.Item key={'LeaveRequestsList'} icon={<ContainerTwoTone />}>
                <Link to={'/LeaveRequestList'}>
                  Leave Requests
                  <Badge count={leaveCount} offset={[10, 0]} size="small" style={{ backgroundColor: '#1677FF' }} />
                </Link>
              </Menu.Item>

            )}
            <Menu.Item key={'EmployeeHandbook'} icon={<BookTwoTone />}>
              <Link to={'/employee-handbook'}>Employee Handbook</Link>
            </Menu.Item>

            {currentAdmin?.department === 'Marketing' && (
              <>
                {!collapsed && (
                  <Menu.Item key={'Divider'} disabled>
                    <span className="sidebar-heading">Apps</span>
                  </Menu.Item>
                )}
                <Divider />
                <SubMenu
                  key={'Marketing Tools'}
                  icon={<ReconciliationTwoTone />}
                  title={'Marketing Tools'}
                >
                  <Menu.Item key={'ColorPicker'}>
                    <Link to={'/colorpicker'}>Color Picker</Link>
                  </Menu.Item>
                  <Menu.Item key={'MetaLengthChecker'}>
                    <Link to={'/meta-length-checker'}>Meta Length Checker</Link>
                  </Menu.Item>
                  <Menu.Item key={'AITextDetector'}>
                    <Link to={'/ai-text-detector'}>AI Text Detector</Link>
                  </Menu.Item>
                  <Menu.Item key={'PageSpeedInsights'}>
                    <Link to={'/page-speed-insights'}>Page Speed Insights</Link>
                  </Menu.Item>
                  <Menu.Item key={'VoiceOver'}>
                    <Link to={'/voice-over'}>Text to Speech</Link>
                  </Menu.Item>
                  <Menu.Item key={'GoogleTrends'}>
                    <Link to={'/google-trends'}>Google Trends</Link>
                  </Menu.Item>
                  <Menu.Item key={'GoogleKeywordsPlanner'}>
                    <Link to={'/google-keywords-planner'}>Google Keywords Planner</Link>
                  </Menu.Item>
                </SubMenu>
                {!collapsed && (
                  <Menu.Item key={'Divider2'} disabled>
                    <span className="sidebar-heading">Forms</span>
                  </Menu.Item>
                )}
                <Divider />
              </>
            )}

            <SubMenu
              key={'Feedbacks and Requests'}
              icon={<ProjectTwoTone />}
              title={'Feedback & Request'}
            >

              <Menu.Item key={'LeaveRequestsList'} >
                <Link to={'/LeaveRequestList'}>
                  Leave Requests
                  <Badge count={leaveCount} offset={[10, 0]} size="small" style={{ backgroundColor: '#1677FF' }} />
                </Link>
              </Menu.Item>
              <Menu.Item key={'SuggestionsComplaintForm'}>
                <Link to={'/suggestions&complaints'}>Submit Feedback/Complaint</Link>


              </Menu.Item>
              {(hasAccess('suggestionList')) && (
                <Menu.Item key={'suggestionList'}>
                  <Link to={'/suggestion-list'}>Feedback & Complaint Log</Link>
                </Menu.Item>
              )}

              {hasAccess('AppraisalDashboard') && (
                <Menu.Item key={'AppraisalDashboard'}>
                  <Link to={'/appraisaldashboard'}>
                    Review Appraisals
                    <Badge count={reviewAppraisalCount} offset={[10, 0]} size="small" style={{ backgroundColor: '#1677FF' }} />
                  </Link>
                </Menu.Item>
              )}

              <Menu.Item key={'AppraisalHistory'}>
                <Link to={'/appraisalhistory'}>
                  Appraisals
                  <Badge count={selfAppraisalCount} offset={[10, 0]} size="small" style={{ backgroundColor: '#1677FF' }} />
                </Link>
              </Menu.Item>
            </SubMenu>



            <>
              {(
                hasAccess('AttendanceLog') ||
                hasAccess('AttendanceReportsHR') ||
                hasAccess('TechnicianLogs') ||
                hasAccess('TimeInRecords') ||
                hasAccess('OvertimeTable') ||
                hasAccess('LeaveBenefitRequests')
              ) && (
                  <SubMenu key={'Reports'} icon={<ReconciliationTwoTone />} title={'Reports'}>
                    {(hasAccess('AttendanceLog') || hasAccess('AttendanceReportsHR')) && (
                      <Menu.Item key={'AttendanceReport'}>
                        <Link to={'/daily-activity-log'}>Daily Activity Log</Link>
                      </Menu.Item>
                    )}

                    {hasAccess('TechnicianLogs') && (
                      <Menu.Item key={'TechnicianLogs'}>
                        <Link to={'/technician-logs'}>Technicians Activity</Link>
                      </Menu.Item>
                    )}

                    {hasAccess('OvertimeTable') && (
                      <Menu.Item key={'OvertimeTable'}>
                        <Link to={'/overtime-extrahours'}>Overtime and Deductions</Link>
                      </Menu.Item>
                    )}

                    {hasAccess('LeaveBenefitRequests') && (
                      <Menu.Item key={'LeaveBenefitRequests'}>
                        <Link to={'/leavebenefitrequests'}>Leave Benefit Requests</Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}
            </>

            {/* {hasAccess( '*') && (
              <>
                {!collapsed && (
                  <Menu.Item key={'HRHeading'} disabled>
                    <span className="sidebar-heading">Human Resources</span>
                  </Menu.Item>
                )}

                {hasAccess( 'Recruitment') && (
                  <Menu.Item key={'Recruitment'} icon={<ContactsTwoTone />}>
                    <Link to={'/recruitment'}>Recruitment Panel</Link>
                  </Menu.Item>
                )}

                {hasAccess( 'Employees') && (
                  <Menu.Item key={'Employees'} icon={<ProfileTwoTone />}>
                    <Link to={'/employees'}>Employee Management</Link>
                  </Menu.Item>
                )}

                {hasAccess( 'SalarySlipForm') && (
                  <Menu.Item key={'SalarySlipForm'} icon={<DollarTwoTone />}>
                    <Link to={'/salary-management'}>Salary Management</Link>
                  </Menu.Item>
                )}

                {hasAccess( 'hiringRequisitionPanal') && (
                  <Menu.Item key={'hiringRequisitionPanal'} icon={<FolderOpenTwoTone />}>
                    <Link to={'/hire-req'}>Open Positions</Link>
                  </Menu.Item>
                )}

                {hasAccess( 'hiringRequisitionRequest') && (
                  <Menu.Item key={'hiringRequisitionRequest'} icon={<FileAddTwoTone />}>
                    <Link to={'/hire-req/create'}>Hiring Requests</Link>
                  </Menu.Item>
                )}
              </>
            )} */}
            <>
              {/* Show HR heading only if sidebar is expanded AND user has access to any HR-related section */}
              {!collapsed &&
                (
                  hasAccess('Recruitment') ||
                  hasAccess('Employees') ||
                  hasAccess('SalarySlipForm') ||
                  hasAccess('hiringRequisitionPanal') ||
                  hasAccess('hiringRequisitionRequest')
                ) && (
                  <Menu.Item key={'HRHeading'} disabled>
                    <span className="sidebar-heading">Human Resources</span>
                  </Menu.Item>
                )
              }

              {hasAccess('Recruitment') && (
                <Menu.Item key={'Recruitment'} icon={<ContactsTwoTone />}>
                  <Link to={'/recruitment'}>Recruitment Panel</Link>
                </Menu.Item>
              )}

              {hasAccess('Employees') && (
                <Menu.Item key={'Employees'} icon={<ProfileTwoTone />}>
                  <Link to={'/employees'}>Employee Management</Link>
                </Menu.Item>
              )}

              {(hasAccess('SalarySlipForm') || hasAccess('Salarymanagement')) && (
                <Menu.Item key={'Salarymanagement'} icon={<DollarTwoTone />}>
                  <Link to={'/salary-management'}>Salary Management</Link>
                </Menu.Item>
              )}

              {hasAccess('HireReqForm') && (
                <Menu.Item key={'HireReqForm'} icon={<FolderOpenTwoTone />}>
                  <Link to={'/hire-req'}>Open Positions</Link>
                </Menu.Item>
              )}

              {hasAccess('HireReqForm') && (
                <Menu.Item key={'HireReqForm'} icon={<FileAddTwoTone />}>
                  <Link to={'/hire-req/create'}>Hiring Requests</Link>
                </Menu.Item>
              )}
            </>


          </Menu>
          <Menu mode="inline" theme="light">
            {hasAccess('Settings') &&

              <Menu.Item
                key={'settings'}
                icon={<SettingTwoTone twoToneColor="#1890ff" />}
                onClick={() => setSettingsModalOpen(true)}
              >
                Settings
              </Menu.Item>
            }
          </Menu>
          {/* Settings Modal */}
          <Modal
            title="Settings"
            open={settingsModalOpen}
            onCancel={() => setSettingsModalOpen(false)}
            footer={null}
            width={500}
          >
            <List
              itemLayout="horizontal"
              dataSource={settingsOptions}
              renderItem={(item) => (
                <List.Item
                  style={{ cursor: 'pointer', padding: '12px' }}
                  onClick={() => handleSettingClick(item.path)}
                  className="settings-list-item"
                >
                  <List.Item.Meta
                    avatar={<span style={{ fontSize: '20px' }}>{item.icon}</span>}
                    title={<span style={{ fontWeight: 500 }}>{item.title}</span>}
                    description={item.description}
                  />
                </List.Item>
              )}
            />
          </Modal>

          {/* Optional: Add some hover effect with CSS */}
          <style jsx>{`
  .settings-list-item:hover {
    background-color: #f5f5f5;
    border-radius: 4px;
  }
`}</style>
        </Sider>

      ) : null}

    </>
  );
}
